export const benchmark = async <T>(
  description: string,
  handler: (() => Promise<T>) | Promise<T>
): Promise<T> => {
  const before = performance.now()
  let res

  if (typeof handler === "function") {
    res = await handler()
  } else {
    res = await handler
  }

  console.log(description, performance.now() - before, "ms")

  return res
}
